import { render, staticRenderFns } from "./Boss.vue?vue&type=template&id=23d7080b&scoped=true"
import script from "./Boss.vue?vue&type=script&lang=js"
export * from "./Boss.vue?vue&type=script&lang=js"
import style0 from "./Boss.vue?vue&type=style&index=0&id=23d7080b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d7080b",
  null
  
)

export default component.exports